import './styles/global/fonts.css'
import './styles/global/variables.css'
import './styles/global/global.css'

import {React, StrictMode, createContext} from 'react';
import {createRoot} from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from './pages/Home';
import Authorization from './pages/Authorization';
import Root from './pages/Root';

export const Context = createContext(null);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        errorElement: <Home />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
              path: "authorization",
              element: <Authorization />,
            },
        ],
    },
]);

root.render(
    <StrictMode>
        <Context.Provider>
            <RouterProvider router={router} />
        </Context.Provider>
    </StrictMode>,
);